module.exports = __webpack_public_path__ + "img/bleuet_4895.644d1e5b.jpg";